import React from 'react';

import CameraManager from '../../../../../viewer/camera-manager';
import { ReferencePlane } from '../../../../../viewer/elements/reference-plane/reference-plane';
import { SceneManager } from '../../../../../viewer/scene-manager';
import { SunManager } from '../../../../../viewer/sun-manager';
import {
  resolveClassicSceneType,
  toClassicSceneTransformation,
} from '../../../../../viewer/view-scenes';
import { ViewSettings } from '../../../../../viewer/view-settings';
import { useActiveTimelineContainer } from '../../../../hooks/use-active-timeline-container';
import { SkyviewContext } from '../../../skyview/skyview-state';

const useToolbar = () => {
  const { skyview } = React.useContext(SkyviewContext);

  const occlusionCulling = skyview.getOcclusionCulling();
  const timelineContainerId = useActiveTimelineContainer()!.id;

  const referencePlane = ReferencePlane.instance.Visibility
    ? {
        mas: Math.round(ReferencePlane.instance.ReferenceHeight * 100) / 100,
        opacity: ReferencePlane.instance.Opacity * 100,
        color: ReferencePlane.instance.Color,
      }
    : undefined;

  const activeSceneType = SceneManager.instance.getActiveSceneType();
  // The CAD viewer has no classic view to save the view in
  if (activeSceneType !== 'skyviewScene' || ViewSettings.instance.isCadViewer) {
    throw new Error(`Invalid scene type '${activeSceneType}'.`);
  }
  const sceneType = resolveClassicSceneType();

  // A shared view is saved in the classic view's scene, which had its own origo
  const activeCameraTransformation = CameraManager().getActiveCamera()?.extractTransformation();
  const cameraTransformation =
    activeCameraTransformation &&
    toClassicSceneTransformation(activeCameraTransformation, sceneType);

  const sunDirectionPercent = SunManager.instance.isDirectionEnabled()
    ? SunManager.instance.getDirectionPercent()
    : undefined;

  return {
    cameraTransformation,
    occlusionCulling,
    referencePlane,
    sceneType,
    sunDirectionPercent,
    timelineContainerId,
  };
};

export { useToolbar };
